// @ts-strict-ignore
/* eslint-disable camelcase */
import classNames from 'classnames'
import React from 'react'

interface SelectProps {
  name: string
  value: string
  options: Array<object>
  onChange: Function
  prefixIcon?: string
}

const Select = ({ name, value, options, onChange, prefixIcon }: SelectProps) => {
  return (
    <select
      className={classNames('Select', { Select__prefixIcon: prefixIcon })}
      id={name}
      name={name}
      onChange={onChange}
      value={value}
      style={{
        backgroundImage: prefixIcon
          ? `url(/fs-core-assets/icons/money/${prefixIcon}.svg?v=13#${prefixIcon}), url(/fs-core-assets/icons/money/chevron-down.svg?v=13#chevron-down)`
          : 'url(/fs-core-assets/icons/money/chevron-down.svg?v=13#chevron-down',
      }}
    >
      {options.map((ele: any, index: number) => {
        return (
          <option key={index} value={ele.value}>
            {ele.text}
          </option>
        )
      })}
    </select>
  )
}

export default Select
